import { render, staticRenderFns } from "./ElPreviewer.vue?vue&type=template&id=32b2d0f3&"
import script from "./ElPreviewer.vue?vue&type=script&lang=ts&"
export * from "./ElPreviewer.vue?vue&type=script&lang=ts&"
import style0 from "./ElPreviewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports